import { useCallback, useContext, useEffect } from 'react'
import * as React from 'react'
import CategoryTile from 'LuxKit/CategoryTile'
import { useInView } from 'react-intersection-observer'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'
import { EventDataKey } from 'home/pages/HomePage/useHomepageAnalytics'

interface CruiseDestination {
  name: string
  image: App.Image
  filter: string
}

interface Props extends Omit<React.ComponentProps<typeof CategoryTile>, 'onClick' | 'align'> {
  destination: CruiseDestination
  position: number
  align: 'top'
}

function CruiseDestinationsSectionItem({ destination, position, ...categoryTileProps }: Props) {
  const dispatchOfferListEvent = useContext(OfferListEventsContext)
  const [inViewRef, trackingInView] = useInView({ triggerOnce: true, threshold: 1 })

  const onClick = useCallback(() => {
    dispatchOfferListEvent({
      type: OfferListEvents.destinationClick,
      destination: {
        destinationId: destination.image.id ?? '',
        destinationName: destination.name,
        tileType: 'tile',
        destinationImageId: destination.image.id,
      },
      position,
      key: EventDataKey.DestinationClick,
    })
  }, [dispatchOfferListEvent, destination, position])

  useEffect(() => {
    if (trackingInView) {
      dispatchOfferListEvent({
        type: OfferListEvents.destinationImpression,
        destination: {
          destinationId: destination.image.id ?? '',
          destinationName: destination.name,
          tileType: 'tile',
          destinationImageId: destination.image.id,
        },
        position,
        key: EventDataKey.DestinationImpression,
      })
    }
  }, [trackingInView, dispatchOfferListEvent, destination, position])

  return (
    <CategoryTile
      href={categoryTileProps.href}
      image={categoryTileProps.image}
      heading={categoryTileProps.heading}
      subHeading={categoryTileProps.subHeading}
      align={categoryTileProps.align}
      callToAction={categoryTileProps.callToAction}
      onClick={onClick}
      ref={inViewRef}
    />
  )
}

export default CruiseDestinationsSectionItem
